// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__8XiOs","links":"MainNavigation_links__ygi8I","active":"MainNavigation_active__5O1Bg"};